var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-lazy-image',{staticClass:"lazy-image",attrs:{"alt":_vm.alt,"src":_vm.src,"src-placeholder":_vm.srcPlaceholder},nativeOn:{"error":function($event){return _vm.imgLoadError.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }